export enum TwoFactorMethod {
  AUTHENTICATOR_APP = 'AUTHENTICATOR_APP',
  EMAIL = 'EMAIL',
}

export type OTPCode = {
  otp?: string
}
